// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","viewSummary":"_1MYIt6VLcKRC1CVvj5vLLO","isBig":"_3PYjCfe3IoHYN08Djx5r8Q"};